import { type FunctionComponent } from 'react'

import { stopLoading } from '~/actions/loadingActions'

import Button from '~/components/Common/Button'

import { useDispatch } from 'react-redux'

import Spinner from '../../Common/Spinner'

const Loading: FunctionComponent = (): JSX.Element => {
  const dispatch = useDispatch()

  const isNonProduction = import.meta.env.MODE !== 'production'

  return (
    <div className="z-8 fixed left-0 top-0 flex h-full w-full flex-col items-center justify-center gap-4 bg-th-content opacity-90">
      <Spinner className="h-14 w-14" />
      {isNonProduction && (
        <Button bordered onClick={() => dispatch(stopLoading())}>
          Override Loading
        </Button>
      )}
    </div>
  )
}

export default Loading
